export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff522e74f16de3bdbeb5c6a9600e690f39cb43bae&name=fetchTypeahead!'